<h2>{{ "upload-source" | transloco }}</h2>

<!-- <div *ngIf="enableSourceFileListUpload === null" class="loader-container-outer">
<div class="loader-container-inner">
  <div class="ui active centered inline loader"></div>
</div>
</div> -->

<!-- <ng-container *ngIf="enableSourceFileListUpload === false">
<div id="container">
  <div>
    <div class="flex-grow"></div>
    <div class="lbl-container">
      <label>{{ "source-type" | transloco }}</label>
    </div>
    <div #dropDown class="ui search selection dropdown">
      <input class="search" autocomplete="off" />
      <div class="text"></div>
      <div class="menu"></div>
      <i class="chevron down icon"></i>
    </div>
  </div>

  <div [hidden]="!showSubtype" class="subtype">
    <div class="flex-grow"></div>
    <div class="lbl-container">
      <label>{{ "subtype" | transloco }}</label>
    </div>
    <div #subTypeDropDown class="ui search selection dropdown">
      <input class="search" autocomplete="off" />
      <div class="text"></div>
      <div class="menu"></div>
      <i class="chevron down icon"></i>
    </div>
  </div>

  <div>
    <div class="flex-grow"></div>
    <div>
      <div
        id="file-upload"
          title="{{
            !sourceId ? 'Please select a source from the dropdown' : undefined
          }}"
        >
        <input
          type="file"
          #sourceFileUpload
          id="list-upload-btn"
          (change)="initFile($event.target.files)"
          [ngClass]="{ disabled: !isUploadEnabled() }"
          />
      </div>
    </div>
  </div>

  <div>
    <div class="flex-grow"></div>

    <div
      title="{{ !sourceFile ? 'Please upload a source file' : undefined }}"
      >
      <div
        (click)="bulkUpload()"
        id="upload-btn"
        class="ui primary background button"
          [ngClass]="{
            loading: isLoading,
            disabled: !isUploadEnabled() || !sourceFile
          }"
        >
        {{ "upload" | transloco }}
      </div>
    </div>
  </div>
</div>

<div #uploadModal id="upload-modal" class="ui tiny modal">
  <div class="icon modal-close close"></div>
  <div
    class="icon"
      [ngClass]="{
        'green-success': !bulkAddSourceAnswer?.error,
        'red-error': bulkAddSourceAnswer?.error
      }"
  ></div>

  <div class="content">
    <h3>
      {{ bulkAddSourceAnswer?.message }}
      {{ bulkAddSourceAnswer?.error && "Incorrect file setup" }}
    </h3>

    <p>{{ bulkAddSourceAnswer?.error?.message }}</p>
  </div>

  <div class="actions">
    <div class="ui primary background button approve">
      {{ "ok" | transloco }}
    </div>
  </div>
</div>

<div
  class="upload-mode-radio"
  *ngIf="sourceId && showAppendOrReplace && uploadModeAcceptType"
  >
  <p>{{ "upload-mode" | transloco }}</p>
  <div style="padding: 5px">
    <input
      type="radio"
      name="uploadMode"
      [value]="'append'"
      (change)="updateUploadMode('append')"
      [checked]="isAppendOrReplace === 'append'"
      class="upload-mode"
      style="width: auto"
      />
    <span>
      {{
      config.tenant === tenants.FR ? "Add New Data" : "Append Data"
      }}</span
      >
    </div>
    <div style="padding: 5px">
      <input
        type="radio"
        name="uploadMode"
        [value]="'replace'"
        (change)="updateUploadMode('replace')"
        [checked]="isAppendOrReplace === 'replace'"
        class="upload-mode"
        style="width: auto"
        />
      <span> {{ "replace-data" | transloco }}</span>
    </div>
  </div>
</ng-container> -->

<!-- <ng-container *ngIf="enableSourceFileListUpload === true"> -->
@if (!showUploadSourceResult) {
<div>
  @if (baseSourceList?.length > 0) {
  <table id="list" width="100%" cellspacing="0">
    <thead>
      <tr>
        <td width="300px">{{ "name" | transloco }}</td>
        <td width="200px">{{ "current-file-name" | transloco }}</td>
        <td width="200px">{{ "last-time-updated" | transloco }}</td>
        <td width="200px" [ngClass]="{ disabled: isProcessingFiles }">
          {{ "drag-drop-to-upload" | transloco }}
        </td>
        <td width="200px"></td>
      </tr>
    </thead>
    <tbody>
      @for (source of baseSourceList; track source) {
      <tr>
        <td>{{ source.name }}</td>
        <td>{{ sourceFileNameMap[source.id]?.fileName }}</td>
        <td>
          {{ sourceFileNameMap[source.id]?.updatedAt }}
        </td>
        <td
          class="drag-drop-file-upload"
          [ngClass]="{
            droppingFiles: isDroppingFiles,
            disabled: isUploadingFiles
          }"
        >
          <div
            file-drop-zone
            class="file-drop-zone"
            (onFileOver)="onFileOver()"
            (onFileDrop)="onFilesDropped($event)"
            (onFileLeave)="onFileDragLeave()"
            [disabled]="isProcessingFiles"
            [ngClass]="{ disabled: isProcessingFiles }"
          ></div>
        </td>
        <td>
          @if (sourceFileNameMap[source.id]?.fileName) {
          <div>
            <button
              class="ui primary button"
              (click)="showDeleteFilePopup(sourceFileNameMap[source.id]?.id)"
            >
              {{ "delete-file" | transloco }}
            </button>
          </div>
          }
        </td>
        <!-- <td class="type">
              {{ source.type === "csv" ? "CSV / XLSX" : source.type }}
            </td>
            <td>{{ source.requireAtlasId ? "Yes" : "No" }}</td>
            <td>{{ source.config }}</td>
            <td class="td-chkbox">
              <div class="ui checkbox" [title]="getHiddenTooltip()">
                <input
                  type="checkbox"
                  [checked]="source.hidden"
                  [disabled]="!isSuperAdmin"
                  (click)="saveSourceHidden(source, $event)"
                  />
                <label></label>
              </div>
            </td>
            <td
              *ngIf="!isProductionMode"
              class="edit"
              align="right"
              (click)="openSourceModal(source)"
          [hidden]="
            source.type === 'prefill' ||
            source.type === 'questionnaire' ||
            source.type === 'travelDiary'
          "
              >
              {{ "settings.edit" | transloco }}
            </td>
            <td
          *ngIf="
            source.type === 'prefill' ||
            source.type === 'questionnaire' ||
            source.type === 'travelDiary'
          "
            ></td>
            <td
              class="questions"
              align="right"
              width="1px"
              [routerLink]="[source?.id]"
              >
              {{ "settings.questions" | transloco }}
            </td> -->
      </tr>
      }
    </tbody>
  </table>
  }
</div>
} @if (showUploadSourceResult) {
<div>
  @if (uploadedXlsxFiles.length > 0) {
  <table id="list" width="100%" cellspacing="0">
    <thead>
      <tr>
        <td width="300px">Source Name</td>
        <td width="200px">{{ "file-name" | transloco }}</td>
        <td width="100px"></td>
        <td></td>
      </tr>
    </thead>
    <tbody>
      @for (file of uploadedXlsxFiles; track file; let i = $index) {
      <tr>
        <td>{{ file.source.name }}</td>
        <td>{{ file.file.name }}</td>
        <td style="text-align: center;">
          <div
            class="icon"
            [ngClass]="{
              'green-success': file.uploadStatus === 'S',
              'red-error':
                file.uploadStatus === 'F' || file.uploadStatus === 'C'
            }"
          ></div>
        </td>
        <td
          (click)="
            (file.uploadStatus === 'F' || file.uploadStatus === 'C') &&
              showUploadErrorPopup(i)
          "
        >
          @if (file.uploadStatus === 'S') {
          <div>
            {{ "source-upload-success" | transloco }}
          </div>
          } @if (file.uploadStatus === 'F' || file.uploadStatus === 'C') {
          <div>
            {{ "source-upload-error" | transloco }}
          </div>
          }
        </td>
      </tr>
      }
    </tbody>
  </table>
  }
  <div class="close-page-btn">
    <button class="ui primary button" (click)="toggleShowUploadSourceResult()">
      {{ "close-page" | transloco }}
    </button>
  </div>
</div>
}

<div #uploadListModal id="upload-list-modal" class="ui tiny modal">
  <div class="icon modal-close close"></div>
  @if (isProcessingFiles) {
  <h1>{{ "source-upload-process-started" | transloco }}</h1>
  } @if (uploadError) {
  <h1>{{ "error" | transloco }}</h1>
  } @if (isUploadingFilesCompleted && !uploadError) {
  <h1>
    {{ "source-upload-process-completed" | transloco }}
  </h1>
  }

  <div class="content">
    @if (isProcessingFiles) {
    <div class="loader-container-outer">
      <div class="loader-container-inner">
        <div class="ui active centered inline text loader">
          {{ uploadListModalContent }}
        </div>
      </div>
    </div>
    } @if (uploadError) {
    <div>
      <p>
        {{ uploadListErrorMsg }}
      </p>
    </div>
    } @if (isUploadingFilesCompleted && !uploadError) {
    <div>
      <p>
        {{ uploadListModalContent }}
      </p>
    </div>
    }
  </div>

  <div class="actions">
    <div
      class="ui primary background button approve"
      (click)="toggleShowUploadSourceResult()"
    >
      {{ "ok" | transloco }}
    </div>
  </div>
</div>

<div #uploadListErrorModal id="upload-list-modal" class="ui tiny modal">
  <div class="icon modal-close close"></div>
  <h1>{{ "error" | transloco }}</h1>

  <div class="content">
    <p>{{ uploadListErrorMsg }}</p>
  </div>

  <div class="actions">
    <div class="ui primary background button approve">
      {{ "ok" | transloco }}
    </div>
  </div>
</div>

<div #deleteFilePopup id="delete-file-modal" class="ui tiny modal">
  <div class="icon modal-close close"></div>
  <h1>{{ "deletion-confirmation" | transloco }}</h1>

  <div class="content">
    <p>{{ "want-to-delete-source-file" | transloco }}</p>
  </div>

  <div class="actions">
    <div class="ui primary background button approve">
      {{ "delete" | transloco }}
    </div>
    <div class="ui primary background button deny">
      {{ "cancel" | transloco }}
    </div>
  </div>
</div>

<div #interruptUploadModal id="interrupt-upload-modal" class="ui tiny modal">
  <div class="icon modal-close close"></div>
  <h1>{{ "files-are-being-uploaded" | transloco }}</h1>

  <div class="content">
    <p>{{ "are-you-sure-you-want-to-proceed" | transloco }}</p>
  </div>

  <div class="actions">
    <div class="ui primary background button approve">
      {{ "yes" | transloco }}
    </div>
    <div class="ui primary background button deny">
      {{ "cancel" | transloco }}
    </div>
  </div>
</div>
<!-- </ng-container> -->
